import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FiBarChart2, FiChevronDown } from "react-icons/fi";

export default function StandingsDropdown() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive =
    location.pathname.includes("drivers-standings") ||
    location.pathname.includes("constructors-standings");

  return (
    <div>
      {/* Parent */}
      <button
        onClick={() => setOpen(!open)}
        className={`
          w-full flex items-center justify-between px-4 py-3 rounded-lg
          text-sm transition
          ${
            isActive
              ? "bg-red-500/10 text-red-400"
              : "text-neutral-400 hover:bg-neutral-800 hover:text-white"
          }
        `}
      >
        <div className="flex items-center gap-3">
          <FiBarChart2 />
          Standings
        </div>

        <FiChevronDown
          className={`transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="mt-1 ml-4 space-y-1">
          <SubItem to="/standings/drivers" label="Drivers" />
          <SubItem to="/standings/constructors" label="Constructors" />
        </div>
      )}
    </div>
  );
}

function SubItem({ to, label }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `
        block px-4 py-2 rounded-lg text-sm transition
        ${
          isActive
            ? "bg-red-500/10 text-red-400"
            : "text-neutral-400 hover:bg-neutral-800 hover:text-white"
        }
      `
      }
    >
      {label}
    </NavLink>
  );
}
